/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-one-expression-per-line */
import React, {
  useEffect,
  useState,
  useCallback,
} from 'react';
import { useParams } from 'react-router-dom';

import { BiCalendar } from 'react-icons/bi';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import TableRow from '@material-ui/core/TableRow';
import api from '../../services/api';
import {
  EmployeeResponse,
  Employee,
  ArrayFilters,
} from '../../interfaces/employee';
import EmployeeService from '../../services/employee';
import DepartamentosService from '../../services/departamentos';
import LoaderModal from '../../components/LoaderModal';
import TicketService, { Relatorio } from '../../services/ticket';
// import DownLoadFile from '../../utils/DownLoadFile';
import { Row, Column, IconContainer } from '../../styles/components';
import MainLoader from '../../components/MainLoader';
import AuthService from '../../services/auth';

import {
  Container,
  Title,
  StatusRow,
  CardSection,
  Acoes,
  FlexRow,
  FormWrapper,
  DivTitle,
  Main,
} from './styles';

interface EditParams {
  id: string;
}

const RelatoriosAgendados: React.FC = () => {
  const services = { EmployeeService: new EmployeeService() };
  const datas = { TicketService: new TicketService() };
  const depservice = { DepartamentosService: new DepartamentosService() };
  const authService = { AuthService: new AuthService() };
  const [loading, setLoading] = useState<boolean>(true);
  const [relatorioAgendado, setRelatorioAgendado] = React.useState<any>();
  const [type, setType] = useState<string>();
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(30);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [departamentos, setDepartamentos] = useState<any>([]);
  const [employees, setEmployees] = useState<EmployeeResponse>(
    {} as EmployeeResponse,
  );
  const [titular, setTitular] = useState<any>();
  const [employeesCPF, setEmployeesCPF] = useState<Employee>({} as Employee);
  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{ page }, { quantity: perPage }],
  });
  console.log({ employeesCPF });
  const { id } = useParams<EditParams>();
  console.log({ id });

  const getEmployeesList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await services.EmployeeService.getEmployee(filters);
      setEmployees(response.data);
      setTotalRows(response.data.FuncionarioListaTotal);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    getEmployeesList();
  }, [page, perPage, filters]);

  const handleGetDepartamentos = useCallback(async () => {
    try {
      const response = await depservice.DepartamentosService.getDepartamentos();
      setDepartamentos(response.data.DepartamentoLista);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const getTitular = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }, []);

  useEffect(() => {
    handleGetDepartamentos();
    getTitular();
    localStorage.removeItem('@TransfacilPJ:DepartmentFilter');
  }, []);

  useEffect(() => {
    async function dataTable() {
      try {
        const response = await api.get('api/pjtacom/report/schedule');
        setRelatorioAgendado(response.data);
        setType(relatorioAgendado.json_params.file_type);
        console.log(relatorioAgendado);
      } catch (e) {
        console.log({ e });
      }
    }
      dataTable();
      console.log(relatorioAgendado);
      console.log(type);
  }, []);

  return (
    <>
      {loading && <MainLoader />}
      <Container>
        <Row className="titleWrapper">
          <Column small="1" medium="1" large="1">
            <IconContainer align="center">
              <BiCalendar size={125} />
            </IconContainer>
          </Column>
          <Column small="10" medium="10" large="10" className="TitleContainer">
            <DivTitle>
              <Title>Relatorios Agendados</Title>
            </DivTitle>
          </Column>
        </Row>
        <Main>
          <Paper>
            <Table>
              <TableHead>
                <TableRow className="header">
                  <TableCell>
                    <strong style={{ color: 'var(--purple)' }}>Data de Criação</strong>
                  </TableCell>
                  <TableCell>
                    <strong style={{ color: 'var(--purple)' }}>Data de Atualização</strong>
                  </TableCell>
                  <TableCell>
                    <strong style={{ color: 'var(--purple)' }}>Tipo de Relatório</strong>
                  </TableCell>
                  <TableCell>
                    <strong style={{ color: 'var(--purple)' }}>Tipo de arquivo</strong>
                  </TableCell>
                  <TableCell>
                    <strong style={{ color: 'var(--purple)' }}>Status do Relatório</strong>
                  </TableCell>
                  <TableCell>
                    <strong style={{ color: 'var(--purple)' }}>Download</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {relatorioAgendado &&
                      relatorioAgendado.map((relatorio: Relatorio) => {
                        console.log(relatorio);
                        return (
                          <TableRow key={Math.random()}>
                            <TableCell component="th" scope="row">
                              {relatorio.created_at}
                            </TableCell>
                            <TableCell>{relatorio.updated_at}</TableCell>
                            <TableCell>{relatorio.report_type_display || relatorio.json_params.file_type}</TableCell>
                            <TableCell>{relatorio.json_params.file_type === 'C' ? 'CSV' : 'PDF'}</TableCell>
                            <TableCell>{relatorio.status_display === 'Token expirado' || relatorio.status_display === 'Erro' ? ('Erro no relatório. \n Favor gerar novamente!') : (relatorio.status_display) }</TableCell>
                            <TableCell>{relatorio.file ? (
                              relatorio.status_display === 'Finalizado' ? (
                                <a
                                  href={relatorio.file}
                                  rel="noreferrer"
                                  target="_blank"
                                  download
                                  style={{ color: 'white', cursor: 'pointer', fontWeight: 'bold', backgroundColor: 'var(--orange)', textAlign: 'center', borderRadius: '18px', border: '2px solid var(--orange)', padding: '5px 25px', maxWidth: '100px' }}
                                > Baixar
                                </a>
                            ) : (
                              <p style={{ color: 'var(--purple)', fontWeight: 'bold', backgroundColor: '#DCDCDC', textAlign: 'center', borderRadius: '18px', border: '2px solid #DCDCDC', padding: '5px 5px', maxWidth: '100px' }}> Indisponível! </p>
                            )
                            ) : (
                              <p style={{ color: 'var(--purple)', fontWeight: 'bold', backgroundColor: '#DCDCDC', textAlign: 'center', borderRadius: '18px', border: '2px solid #DCDCDC', padding: '5px 5px', maxWidth: '100px' }}> Indisponível! </p>
                            ) }
                            </TableCell>
                          </TableRow>
                        );
                      })}
              </TableBody>
            </Table>
          </Paper>
        </Main>
        {loadingModal && (
          <LoaderModal
            title="Carregando"
            show={loadingModal}
            handleClose={() => setLoadingModal(false)}
          />
        )}
      </Container>
    </>
  );
};

export default RelatoriosAgendados;
